/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_TakenInputs */

const en_error_email_taken = /** @type {(inputs: Error_Email_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another account already uses this email. Ask for the change again with a different address.`)
};

/**
* | output |
* | --- |
* | "Another account already uses this email. Ask for the change again with a different address." |
*
* @param {Error_Email_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_taken = /** @type {((inputs?: Error_Email_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_taken(inputs)
});